import React from 'react'
import { Col, Row } from 'react-bootstrap';
import img from '../img/features_to_make_web_developer.jpeg'
import img1 from '../img/WebDev-Webmain.png'
import img2 from '../img/seo.jpg'
import Image from 'react-bootstrap/Image';
import './AirExportLogisticsSoftware.css';
import './About.css';
import Sidebar from './Sidebar';

function WebsiteDevelopment() {
  return (
    <>
        <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div className="container my-4">
      <Row>
        <Col xs={12} md={9}>
          <h1 className='mt-5 pt-4 text-danger'>Website Development Services</h1>
          {/* <Image className='my-2 fade-in' src={img} height={500} fluid /> */}
          <p className='fs-6 text-justify'>Your website is often the first impression people have of your business — make it count. At Catus Technologies, we create stunning, functional, and high-performance websites that not only look great but also deliver real results. Whether you need a simple business website, a robust e-commerce platform, or a custom web application, we design and develop solutions tailored to your goals.</p>
          <ul className='fs-6'>
            <h2>Why Choose Our Website Development Services?</h2>
            <li className='fs-6'>Customised Design – Unique, brand-focused designs that stand out and connect with your audience.</li>
            <li className='fs-6'>Responsive & Mobile-Friendly – Optimised for all devices to ensure a seamless user experience.</li>
            <li className='fs-6'>SEO-Friendly Structure – Built with clean code and best practices for higher search rankings.</li>
            <li className='fs-6'>Fast & Secure – Speed-optimised and equipped with advanced security features.</li>
            <li className='fs-6'>Scalable Solutions – Websites that grow with your business needs.</li>
          </ul>
          
          <div className='text-center'><Image className="my-5 fade-in animated-card" src={img2} height={400} /></div>
          <Row>
            <Col md={6}><ul className='fs-6'>
              <h2>Our Development Expertise</h2>
              <li className='fs-6'>Business & Corporate Websites</li>
              <li className='fs-6'>E-commerce Solutions</li>
              <li className='fs-6'>Portfolio & Personal Branding Sites</li>
              <li className='fs-6'>Custom Web Applications</li>
              <li className='fs-6'>CMS Development (WordPress, Drupal, etc.)</li>
              <li className='fs-6'>Landing Pages & Microsites</li>
            </ul></Col>
            <Col md={6} className="d-flex align-items-center justify-content-center">
              <img
                src={img1}
                alt="Features Illustration"
                style={{ width: 300, height: 'auto', borderRadius: '8px' }}
              /></Col>
          </Row>


          <ul className='fs-6'>
            <h2>Benefits to Your Business</h2>
            <li className='fs-6'>Stronger online presence and brand identity.</li>
            <li className='fs-6'>Improved customer engagement and lead generation.</li>
            <li className='fs-6'>Competitive edge with modern design and technology.</li>
            <li className='fs-6'>Reliable performance and long-term maintainability.</li>
          </ul>
          <p className='fs-6 text-justify'>Catus Technologies blends creativity, cutting-edge technology, and industry best practices to deliver websites that inspire, engage, and convert visitors into customers.</p>
          <p className='fs-6 text-justify'>Bring your vision to life with Catus Technologies Website Development Services.</p>
        </Col>

        <Col xs={12} md={3}>
          <Sidebar />
        </Col>
      </Row>
    </div>
    </>
  )
}

export default WebsiteDevelopment